import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HeaderVariant} from '../enums/header-variant';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  title$ = new BehaviorSubject<string | null>(null);
  variant$ = new BehaviorSubject<HeaderVariant>(HeaderVariant.BIG);

  setTitle(title: string | null) {
    this.title$.next(title);
  }

  setVariant(variant: HeaderVariant) {
    this.variant$.next(variant);
  }
}
